export const paneStyles = {
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  minHeight: '520px',
  height: '100%',
  borderRadius: '10px',
  overflow: 'hidden',
};

export const documentWrapperStyles = {
  position: 'relative',
  flex: 1,
  minHeight: '520px',
  borderRadius: '10px',
  overflow: 'hidden',
  border: ({ palette }) => `1px solid ${palette.border.input}`,
};
